import React from "react";

const RightArrowIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.75 0L15 5.60543L8.75 0ZM15 5.60543L8.75 11.2109L15 5.60543ZM15 5.60543H0H15Z" fill="white"/>
    <path d="M8.75 0L15 5.60543M15 5.60543L8.75 11.2109M15 5.60543H0" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  );
};

export default RightArrowIcon;
